export const links = [
  { icon: "home", text: "Home", route: "/" },
  { icon: "info", text: "About", route: "/about" },
  { icon: "maps", text: "Maps", route: "/maps" },
];
